export default __webpack_public_path__ + "images/pesquisar-ico-blue.svg";